import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { moderationListSearchSchema } from '@/entities/moderation';
import {
  createModerationParamsChange,
  moderationLoaderDeps,
  moderationRouteLoader,
  ProductsModerationPage,
  requireAuthBeforeLoad,
} from '@/pages/moderation';

/** Products moderation queue — URL is the single source of truth for status/search/date/page. */
export const Route = createFileRoute('/moderation/products')({
  staticData: { permission: 'moderation.products.view' },
  beforeLoad: requireAuthBeforeLoad,
  validateSearch: moderationListSearchSchema,
  loaderDeps: moderationLoaderDeps,
  loader: moderationRouteLoader('products'),
  component: ProductsModerationRoute,
});

function ProductsModerationRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onParamsChange = createModerationParamsChange(search, (options) => {
    void navigate(options);
  });

  return <ProductsModerationPage params={search} onParamsChange={onParamsChange} />;
}
